import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as ChildObservables from 'web-app/react/entities/children/epics';
import * as ContactActions from 'web-app/react/entities/contacts/actions';
import * as ContactEpics from 'web-app/react/entities/contacts/epics';
import LoginsApi from 'web-app/api/logins-api';
import {getApolloClient} from 'web-app/api/clients/famly-app';
import * as ChangeRoleQueries from 'web-app/react/components/change-role/queries';

import * as Actions from './actions';
import {relationsFromChildren} from './helpers';
import {PARALLEL_QUEUE_STRATEGY} from '../../setup/prototype-extensions/rxjs-extensions';

const fetch = action$ =>
    action$.ofType(Actions.fetchChildren.type).mergeMap(({payload}) =>
        ChildObservables.fetchChildrenObservable(
            payload.institutionId,
            payload.embedRelations,
            payload.includeFuture,
            payload.includePast,
            true,
        )
            .flatMap(childAction =>
                [
                    payload.updateEntities ? childAction : null,
                    Actions.fetchChildrenSuccess.action(childAction.payload.children),
                    ContactActions.addContacts.action(relationsFromChildren(childAction.payload.children)),
                ].filter(a => a),
            )
            .catch(e => Observable.of(Actions.fetchChildrenFailed.action(e))),
    );

const assignRoleObservable = (id, assigneeProps) =>
    Observable.concat(
        Observable.of(Actions.assignRole.action(id)),
        Observable.defer(() => {
            return Observable.fromPromise(
                LoginsApi.assignRole(assigneeProps.newRoleId, assigneeProps.famlyId, assigneeProps.roleTargetId),
            ).mergeMap(() =>
                ContactEpics.fetchChildContactObservable(id).flatMap(action => [
                    action,
                    Actions.assignRoleSuccess.action(id),
                ]),
            );
        }).catch(() => [Actions.assignRoleFailed.action(id)]),
    );

const assignRolesAction = action$ =>
    action$
        .ofType(Actions.assignRoles.type)
        .mergeMap(({payload}) => {
            return Observable.from(payload.assignees.toArray()).map(assigneeProps => {
                return assignRoleObservable(assigneeProps.relationId, assigneeProps);
            });
        })
        .concurrentQueues(2, PARALLEL_QUEUE_STRATEGY.LOAD_BALANCING, action$.ofType(Actions.cancelInvites.type));

const assignRoleInvitationObservable = (id, assigneeProps) =>
    Observable.concat(
        Observable.of(Actions.assignRole.action(id)),
        Observable.defer(() => {
            return Observable.fromPromise(
                getApolloClient().mutate({
                    mutation: ChangeRoleQueries.UpdateRoleMutation,
                    variables: {
                        relationId: id,
                        role: {
                            roleId: assigneeProps.newRoleId,
                        },
                    },
                }),
            ).flatMap(() => {
                return [Actions.assignRoleSuccess.action(id), Actions.assignRoleInvitation.action(id)];
            });
        }).catch(() => [Actions.assignRoleFailed.action(id)]),
    );

const assignRoleInvitationsAction = action$ =>
    action$
        .ofType(Actions.assignRoleInvitations.type)
        .mergeMap(({payload}) =>
            Observable.from(payload.assignees.toArray()).map(assigneeProps => {
                return assignRoleInvitationObservable(assigneeProps.relationId, assigneeProps);
            }),
        )
        .concurrentQueues(2, PARALLEL_QUEUE_STRATEGY.LOAD_BALANCING, action$.ofType(Actions.cancelInvites.type));

export default combineEpics(fetch, assignRolesAction, assignRoleInvitationsAction);
